import { useTranslation } from 'react-i18next';
import caseStudy2Us from './static/caseStudy2-us.webp';
import caseStudy1Us from './static/caseStudy1-us.webp';
import caseStudy3Us from './static/caseStudy3-us.webp';
import caseStudy1Fr from './static/caseStudy1-fr.webp';
import caseStudy2Fr from './static/caseStudy2-fr.webp';
import caseStudy3Fr from './static/caseStudy3-fr.webp';
import caseStudy1Uk from './static/caseStudy1-uk.webp';
import caseStudy2Uk from './static/caseStudy2-uk.webp';
import caseStudy3Uk from './static/caseStudy3-uk.webp';

import  type { Layout } from 'gatsby-plugin-image';

const useSocialContent = () => {
  const { t } = useTranslation();
  const caseStudyImages: { [key: string]: { caseStudy1: string; caseStudy2: string; caseStudy3: string; }; } = { 
    fr: { caseStudy1: caseStudy1Fr, caseStudy2: caseStudy2Fr, caseStudy3: caseStudy3Fr },
    us: { caseStudy1: caseStudy1Us, caseStudy2: caseStudy2Us, caseStudy3: caseStudy3Us },
    uk: { caseStudy1: caseStudy1Uk, caseStudy2: caseStudy2Uk, caseStudy3: caseStudy3Uk },
  };
  
  const setLocaleImg = (pathPrefix: string) => {
    switch (pathPrefix) {
      case 'uk':
        return 'uk';
      case 'fr':
        return 'fr';
      default:
        return 'us';
    }
  };

  const locale = setLocaleImg(t('langCodes_pathPrefix'));

  const data = {
    cards: [
      { headline: t('organisms_scroll_social_proof_card_headline_1'),
        quote: t('organisms_scroll_social_proof_card_quote_1'),
        attributionName: t('organisms_scroll_social_proof_card_attributionName_1'),
        attributionCredentials: t('organisms_scroll_social_proof_card_attributionCredentials_1'),
        image: {
          altText: '',
          gatsbyImage: {
            layout: 'fullWidth' as Layout,
            images: {
              fallback: {
                src: caseStudyImages[locale as keyof typeof caseStudyImages].caseStudy1,
              },
            },
            width: 1380,
            height: 837,
            altText: '',
          },
        },
        href:  t('organisms_scroll_social_proof_card_href_1'),
        quoteStart: t('organisms_scroll_social_proof_quote_start'),
        quoteEnd: t('organisms_scroll_social_proof_quote_end'),

      },
      { headline: t('organisms_scroll_social_proof_card_headline_2'),
        quote: t('organisms_scroll_social_proof_card_quote_2'),
        attributionName: t('organisms_scroll_social_proof_card_attributionName_2'),
        attributionCredentials: t('organisms_scroll_social_proof_card_attributionCredentials_2'),
        image: {
          altText: '',
          gatsbyImage: {
            layout: 'fullWidth' as Layout,
            images: {
              fallback: {
                src: caseStudyImages[locale as keyof typeof caseStudyImages].caseStudy2,
              },
            },
            width: 1380,
            height: 837,
          },
        },
        href:  t('organisms_scroll_social_proof_card_href_2'),
        quoteStart: t('organisms_scroll_social_proof_quote_start'),
        quoteEnd: t('organisms_scroll_social_proof_quote_end'),
      },
      { headline: t('organisms_scroll_social_proof_card_headline_3'),
        quote: t('organisms_scroll_social_proof_card_quote_3'),
        attributionName: t('organisms_scroll_social_proof_card_attributionName_3'),
        attributionCredentials: t('organisms_scroll_social_proof_card_attributionCredentials_3'),
        image: {
          altText: '',
          gatsbyImage: {
            layout: 'fullWidth' as Layout,
            images: {
              fallback: {
                src: caseStudyImages[locale as keyof typeof caseStudyImages].caseStudy3,
              },
            },
            width: 1380,
            height: 837,
          },
        },
        href:  t('organisms_scroll_social_proof_card_href_3'),
        quoteStart: t('organisms_scroll_social_proof_quote_start'),
        quoteEnd: t('organisms_scroll_social_proof_quote_end'),

      },
    ],
    button: t('organisms_scroll_social_proof_button'),
    href:  t('organisms_scroll_social_proof_href'),
  };

  return data;
};

export default useSocialContent;
